import mainStyle from '../mainStyle.module.scss';

import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as DeleteIcon } from 'assets/images/icons/icn_table_cell_Unverified.svg';

import { cloneDeep } from 'lodash';

import MacAddressInputField from 'components/InputField/MacAddressInputField';

const validateMacAddress = macAddress => {
  const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
  return macRegex.test(macAddress);
};

const AddTable = ({ formData, setFormData, showEditGeneral }) => {
  const theme = useTheme();

  const checkInputInvalid = (value, field) => {
    if (value === '') return false; // Empty value is not considered invalid
    const isInvalidMac = validateMacAddress(value) === false;
    const isDuplicate = field !== 'mask' && formData?.addOuiList?.filter(item => item[field] === value).length > 1;
    return isInvalidMac || isDuplicate;
  };

  const handleChangeItemValue = (index, field, value) => {
    const newList = cloneDeep(formData.addOuiList);
    newList[index][field] = value;
    setFormData(prev => ({
      ...prev,
      addOuiList: newList,
    }));
  };

  const handleDeleteItem = itemId => {
    const newList = cloneDeep(formData.addOuiList);
    const updatedList = newList.filter(item => item.id !== itemId);
    setFormData(prev => ({
      ...prev,
      addOuiList: updatedList,
    }));
  };

  return (
    <TableContainer>
      <Table>
        <TableHead
          sx={{
            '& th': {
              color: '#aaaaaa',
              fontSize: '15px',
              fontWeight: '500',
            },
            borderTop: 'none',
            borderColor: '1px solid #d5d5d5',
          }}
        >
          <TableRow>
            <TableCell>
              <Typography className={mainStyle['table-header']}>#</Typography>
            </TableCell>
            <TableCell>
              <Typography className={mainStyle['table-header']}>OUI Address</Typography>
            </TableCell>
            <TableCell>
              <Typography className={mainStyle['table-header']}>Mask</Typography>
            </TableCell>
            <TableCell>
              <Typography className={mainStyle['table-header']}>Description (Optional)</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {formData?.addOuiList?.length > 0 ? (
            formData.addOuiList.map((item, index) => (
              <TableRow
                key={`oui-binding-table-row-${index}`}
                sx={{
                  backgroundColor: index % 2 === 1 ? theme.palette.primary.whiteSecound : theme.palette.primary.white,
                  '& .MuiTableCell-root': { border: 'none', padding: '8px 16px' },
                }}
              >
                {showEditGeneral && (
                  <TableCell>
                    <Typography>{index + 1}</Typography>
                  </TableCell>
                )}
                <TableCell>
                  <MacAddressInputField
                    value={item.address}
                    onChange={newVal => handleChangeItemValue(index, 'address', newVal)}
                    disabled={false}
                    showError={checkInputInvalid(item.address, 'address')}
                  />
                </TableCell>
                <TableCell>
                  <MacAddressInputField
                    value={item.mask}
                    onChange={newVal => handleChangeItemValue(index, 'mask', newVal)}
                    disabled={false}
                    showError={checkInputInvalid(item.mask, 'mask')}
                  />
                </TableCell>
                <TableCell sx={{ display: 'inline-flex' }}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        height: '32px',
                        width: '260px',
                      },
                    }}
                    value={item.description}
                    onChange={e => {
                      handleChangeItemValue(index, 'description', e.target.value);
                    }}
                  />
                  {index !== 0 && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: '10px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleDeleteItem(item?.id)}
                    >
                      <DeleteIcon />
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow></TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AddTable;
